module.exports = __webpack_public_path__ + "img/word_active.b8947b60.svg";